import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import CounterSales from './CounterSales';
import Cart from './Cart';
import SalesHistory from './SalesHistory';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`sales-tabpanel-${index}`}
      aria-labelledby={`sales-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function Sales() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          aria-label="sales tabs"
        >
          <Tab label="Vendite al Banco" />
          <Tab label="Carrello" />
          <Tab label="Storico Vendite" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <CounterSales />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <Cart />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <SalesHistory />
      </TabPanel>
    </Box>
  );
}

export default Sales; 